import styled, { css } from "styled-components";
import { includeStyledSystem, sx } from "../../util/styledSystem";
const getVariants = ({ colors: { inputColors }, shadows }) => ({
    error: {
        "&:disabled": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        "&:focus": {
            borderColor: inputColors.inputFocusBorder,
            boxShadow: shadows.searchBox.contentShadow,
        },
        "&:read-only": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        backgroundColor: inputColors.inputBackground,
        borderColor: inputColors.inputErrorBorder,
    },
    fileInput: {
        "&:disabled": {
            backgroundColor: inputColors.inputFileInputDisabledBackground,
        },
        cursor: "not-allowed",
    },
    noBorder: {
        "&:disabled": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        "&:focus": {
            borderColor: inputColors.inputFocusBorder,
            boxShadow: shadows.searchBox.contentShadow,
        },
        backgroundColor: inputColors.inputBackground,
        border: "0px",
    },
    primary: {
        "&:disabled": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        "&:focus": {
            borderColor: inputColors.inputFocusBorder,
            boxShadow: shadows.searchBox.contentShadow,
        },
        "&:read-only": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        backgroundColor: inputColors.inputBackground,
    },
    success: {
        "&:disabled": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        "&:focus": {
            borderColor: inputColors.inputFocusBorder,
            boxShadow: shadows.searchBox.contentShadow,
        },
        "&:read-only": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        backgroundColor: inputColors.inputBackground,
        borderColor: inputColors.inputSuccessBorder,
    },
});
export const TEXT_FIELD_TEST_ID = "inputText";
const DEFAULT_VARIANT = "primary";
export const InputText = styled.input `
  ${({ theme, theme: { colors: { inputColors }, }, }) => ({
    border: theme.borders[1],
    borderColor: inputColors.inputBorder,
    borderRadius: theme.sizes[1],
    boxSizing: "border-box",
    color: inputColors.inputText,
    fontFamily: theme.fonts.main,
    fontSize: theme.fontSizes[1],
    height: "32px",
    paddingBottom: theme.space[1],
    paddingLeft: theme.space[3],
    paddingRight: theme.space[3],
    paddingTop: theme.space[1],
})}
  ${({ theme, variant = DEFAULT_VARIANT }) => (Object.assign({}, getVariants(theme)[variant]))}
  ${({ theme: { colors: { inputColors }, }, }) => css `
    ::placeholder {
      color: ${inputColors.inputPlaceholder};
    }
  `}
  ${includeStyledSystem()}
  ${sx}
`;
InputText.defaultProps = {
    "data-testid": TEXT_FIELD_TEST_ID,
    placeholder: "",
    variant: DEFAULT_VARIANT,
};
